export default {
  GUEST: 'guest',
  ADMIN: 'admin',
  USER: 'user',
  SHAREE: 'sharee',
  ROLE_CLAIM: 'https://ctz.nz/roles',
  SOURCE_CLAIM: 'service_source',
  APOLLO: 'apollo',
  NON_PATIENT: 'nonpatient'
}
